import { fetcher } from '@rocketlane/state-db';
import { getTaskAdditionalFieldsCollectionQueryKey, getTaskDefaultFieldsCollectionQueryKey, getTaskDetailCollectionQueryKey, refetchTaskInCollection, taskCollection } from 'collections/tasks';
import { queryClient } from 'queries';
const getProjectIdFromCollectionTask = (taskId)=>{
    var _task_project;
    const task = taskCollection.get(taskId);
    if (!task) {
        return undefined;
    }
    if (typeof task.project === 'number') {
        return task.project;
    }
    return (_task_project = task.project) === null || _task_project === void 0 ? void 0 : _task_project.projectId;
};
const invalidateCollectionTaskQueries = (taskId, projectId)=>{
    fetcher.invalidate(getTaskDetailCollectionQueryKey(taskId));
    if (projectId != null) {
        fetcher.invalidate(getTaskDefaultFieldsCollectionQueryKey(projectId, taskId));
        fetcher.invalidate(getTaskAdditionalFieldsCollectionQueryKey(projectId, taskId));
    }
};
export const invalidateTaskQuery = async (taskId, projectIdParam)=>{
    const projectId = projectIdParam !== null && projectIdParam !== void 0 ? projectIdParam : getProjectIdFromCollectionTask(taskId);
    invalidateCollectionTaskQueries(taskId, projectId);
    await queryClient.invalidateQueries({
        predicate: (query)=>{
            const hash = query.queryHash;
            return (hash.includes('task-detail') || hash.includes('tasks:detail')) && hash.includes(taskId.toString());
        }
    });
    if (projectId != null) {
        await refetchTaskInCollection(projectId, taskId);
    }
};
